module.exports = __webpack_public_path__ + "img/tastings.3beaa734.png";